export default __webpack_public_path__ + "static/media/resume-icon.2e360b56.svg";